export * from './IconDocumentSearch';
export { default as IconDocumentSearch } from './IconDocumentSearch';
